export const QueryGroupMemberApi = Symbol.for('QueryGroupMemberApi');
